import type { components } from "@/lib/api/types";

type UserResponse = components["schemas"]["UserResponse"];

/**
 * User data for display in navigation/UI
 */
export interface UserDisplayData {
	name: string;
	email: string;
	avatar?: string;
}

/**
 * Build user display data from user object
 * Generates a display name from first/last name or email
 */
export function getUserDisplayData(user: UserResponse | null): UserDisplayData {
	if (!user) {
		return {
			name: "Guest",
			email: "",
			avatar: undefined,
		};
	}

	// Build display name from available fields
	let name = "";
	if (user.first_name && user.last_name) {
		name = `${user.first_name} ${user.last_name}`;
	} else if (user.first_name) {
		name = user.first_name;
	} else if (user.last_name) {
		name = user.last_name;
	} else {
		// Fallback to part before @ in email
		name = user.email.split("@")[0];
	}

	return {
		name,
		email: user.email,
		avatar: undefined, // Can add avatar URL from user profile when available
	};
}
